import { toRefs } from 'vue'
import { createGlobalState, useEventListener, watchImmediate } from '@vueuse/core'
import { baseUrl } from '../utils'
import { useAudioStore } from '../stores/audio'

export const useAudio = createGlobalState((name: string) => {
  const state = toRefs(useAudioStore().audios[name])
  if (!state) {
    throw new Error(`Error not found audio '${name}'`)
  }

  const audio = state.$audio.value

  useEventListener(audio, 'ended', (event) => {
    skipForward()
  })

  function play() {
    state.status.value = 'playing'
  }

  function pause() {
    state.status.value = 'paused'
  }

  function skipForward() {
    let nextId = state.tracks.value.find((e) => e.id == state.track.value + 1)?.id
    if (!nextId && state.modeRepeat.value) {
      nextId = 1
    }
    if (nextId) {
      state.track.value = nextId
    } else {
      pause()
    }
  }

  function skipTo(newTrackId: number) {
    if (state.tracks.value.find((e) => e.id == newTrackId)) {
      state.track.value = newTrackId
    } else {
      pause()
    }
  }

  watchImmediate(state.track, (track) => {
    // console.log({ track })
    audio.src = baseUrl(state.tracks.value.find((e) => e.id == state.track.value)?.src)
    if (state.status.value == 'playing') {
      audio.play()
    }
  })

  watchImmediate(state.status, (status) => {
    // console.log({ status })
    if (status == 'playing') {
      audio.play()
    } else {
      audio.pause()
    }
  })

  return {
    ...state,
    play,
    pause,
    skipForward,
    skipTo,
  }
})

// export function useAudio(name: string) {
//   const state = toRefs(useAudioStore().audios[name])
//   if (!state) {
//     throw new Error(`Error not found audio '${name}'`)
//   }
//   return { ...state }
// }
